import { useAuth } from "../context/AuthContext.js";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    // Optionally show a loading spinner or just nothing
    return <div className="text-white text-center mt-8">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}
